import {
  WELCOME_MODAL_DOC_CHAT,
  WELCOME_MODAL_DOC_COMPARE,
  WORKFLOW_INTRO_MODAL,
} from '../Constants/commonConstants';

export const appLocalStorageClear = () => {
  const keysToKeep = new Set([
    'user_id',
    WELCOME_MODAL_DOC_COMPARE,
    WELCOME_MODAL_DOC_CHAT,
    WORKFLOW_INTRO_MODAL,
  ]);

  Object.keys(localStorage).forEach((key) => {
    if (!keysToKeep.has(key)) {
      localStorage.removeItem(key);
    }
  });
};
